// Core
import PodoCore from './core';
// Logical addons
import update from './services/update';
import helper from './services/helper';
import bus from './services/bus';
import storage from './services/storage';
import acl from './services/acl';
import cognito from './services/cognito';
import entities from './services/entities';
import repository from './services/repository';
import doctor from './services/doctor';
import analytics from './services/analytics';
import analysis from './services/analysis';
import commons from './services/commons';
import addons, { EAddons } from './services/addons';

import { getProcessEnv } from '@/lib/build';

export default new PodoCore([
  new update({
    interval: 300000,
  }),
  new helper({}),
  new bus({}),
  new storage({}),
  new acl({}),
  new cognito({
    identityPoolId: getProcessEnv('COGNITO_IDENTITY_POOL_ID'),
    region: process.env.VUE_APP_COGNITO_REGION as string,
    userPoolId: getProcessEnv('COGNITO_USER_POOL_ID'),
    userPoolWebClientId: getProcessEnv('COGNITO_USER_POOL_WEB_CLIENT_ID'),
  }),
  new entities({
    soles: {
      queryParams: {
        $limit: 50,
        $skip: 0,
        $sort: {
          updatedAt: -1,
        },
      },
    },
    stations: {
      queryParams: {
        $limit: 5,
        $skip: 0,
        $sort: {
          online: -1,
        },
      },
    },
    patients: {
      queryParams: {
        $limit: 10,
        $skip: 0,
        $sort: {
          'infos.lastName': 1,
        },
        $select: ['_id', 'infos'],
        // @ts-ignore
        $populate: [
          {
            path: 'acquisitions',
            options: {
              sort: {
                createdAt: -1,
              },
              populate: {
                path: 'pathologies.reference',
              },
            },
          },
          {
            path: 'infos.pathologies.reference',
          },
        ],
      },
    },
    doctors: {
      queryParams: {},
    },
    acquisitions: {
      queryParams: {
        // @ts-ignore
        $populate: {
          path: 'pathologies.reference',
        },
      },
    },
    commands: {
      queryParams: {
        // @ts-ignore
        command: {
          $in: ['start acquisition', 'acquisition data'],
        },
        $sort: {
          createdAt: -1,
        },
      },
    },
  }),
  new repository({
    type: 'socket',
    options: {
      url: getProcessEnv('CLOUD_URL'),
    },
  }),
  new doctor({}),
  new analytics({
    key: getProcessEnv('SEGMENT_KEY'),
  }),
  new analysis(),
  new commons({
    cloudUrl: getProcessEnv('CLOUD_URL'),
  }),
]);
